import { render, staticRenderFns } from "./ManagerCampEditorPlacement.vue?vue&type=template&id=224c98da&lang=pug&"
import script from "./ManagerCampEditorPlacement.vue?vue&type=script&lang=js&"
export * from "./ManagerCampEditorPlacement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports